import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import ToggleButton from 'vue-js-toggle-button'
import VueSpeech from 'vue-speech'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(ToggleButton)
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.use(VueSpeech)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
